import { NoRouterHijack } from "../support/Hijack.js";
import jss from '../jss';
import { getClassGen } from '../jss';

import React, { useState, useEffect, useRef } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { StylesProvider } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import LaunchIcon from '@material-ui/icons/Launch';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import Tooltip from '@material-ui/core/Tooltip';

const popupStyles = makeStyles((theme) => ({
   
    popupLink: {
        color: 'var(--red)',
        cursor: 'pointer',
        display: "flex",
        alignItems: "flex-end",
        "&:hover": {
            color: "var(--black)"
        },
        paddingBottom: "5px"
    },
    popupButton: {       
      color: "var(--darkBlue)"

    },
    icon: {
        marginLeft: "8px",
        marginRight: "4px"
    },
    contentContainer: {             
          "& img": {
              width: '100%',
              height: 'auto'
        },
    },
    image: {
        maxWidth: '100%'
    },
    imageBox: {
        cursor: 'zoom-in'
    }


}));
const Popup = (props) => {
    const [open, setOpen] = useState(false)
    const classes = popupStyles();
    const htmlRef = useRef(null);
    return (
        <StylesProvider jss={jss} generateClassName={getClassGen(false)}>
            <div className={classes.popupLink} onClick={() => setOpen(true)} color="primary">
                {props?.isVideo ? <PlayCircleOutlineIcon className={classes.icon} /> : ""}
                <div display="inline" dangerouslySetInnerHTML={{ __html: props.title ?? "" }}></div>
                {props.hideIcon !== true ? <LaunchIcon className={classes.icon} /> : null}
            </div>
            <Dialog open={open} fullWidth={true} maxWidth={props?.isVideo ? "md" : "lg"} onClose={() => { setOpen(false); }} aria-labelledby={"form-dialog-video-" + props.title}>
                <DialogContent><NoRouterHijack><div className={classes.contentContainer} ref={htmlRef} dangerouslySetInnerHTML={{ __html: props.content ?? "" }} /></NoRouterHijack></DialogContent>
                <DialogActions>
                    <Button onClick={() => { setOpen(false); }} color="default" className={classes.popupButton}> Close</Button>
                    </DialogActions>
                </Dialog>
        </StylesProvider>

    );
};
const EnlargeImage = (props) => {
    const [open, setOpen] = useState(false)
    const classes = popupStyles();
    const [tip, setTip] = useState(false);
    return (
        <StylesProvider jss={jss}>
            <Tooltip open={tip} title="click to enlarge" onOpen={() => setTip(true)} onClose={() => setTip(false)}>
                <Box className={classes.imageBox} onClick={() => setOpen(true)} color="primary"><div display="inline" dangerouslySetInnerHTML={{ __html: props.item ?? "" }}></div></Box>
                </Tooltip>

            <Dialog open={open} fullWidth={true} maxWidth="lg" onClose={() => { setOpen(false); }}>
                <DialogContent><img src={props.image} className={classes.image} /></DialogContent>
                <DialogActions>
                    <Button onClick={() => { setOpen(false); }} color="default" className={classes.popupButton}> Close</Button>
                </DialogActions>
            </Dialog>
        </StylesProvider>

    );
};

export default Popup;
export { EnlargeImage };